// Formats a Belgian enterprise number as a VAT number: "BE 0123.456.789".
// Accepts the forms people type: "0123456789", "0123.456.789",
// "BE0123456789", or an older nine-digit number.
export function formatVatNumber(raw: string | undefined | null): string {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  const padded = digits.length === 9 ? `0${digits}` : digits;
  if (padded.length !== 10) return raw.trim();
  return `BE ${padded.slice(0, 4)}.${padded.slice(4, 7)}.${padded.slice(7)}`;
}
